import React, { useMemo, useState } from 'react';

function CalculateArea() {
    const [value, setValue] = useState(0);
    const Areavalue = useMemo(() => {
        console.log("🔁 useMemo recalculating...");
        return value * value;
    }, [value]);


    return (
        <div>
            <p>Radius : {value}</p>
            <p>Area of square: {Areavalue}</p>
            <button onClick={() => setValue(value + 1)}>Calculate</button>
        </div>
    )
}

export default CalculateArea
